<template>
  <section class="bundleProducts pt-8 mx-auto w-10/12">
    <div class="row grid-margin">
      <v-button md primary class="ml-3 mt-1 mb-5" @click.prevent="goToCatalog()">
        <v-arrow-left-icon /> <span>Naar catalogus</span>
      </v-button>
    </div>
    <div class="row grid-margin">
      <div class="col-xs-12">
        <legend class="text-lg mb-3 text-pdsPrimaryColor">
          {{ bundleDetails.bundleName }}
        </legend>
        <legend>
          {{ bundleDetails.bundleDescription }}
        </legend>
      </div>
    </div>
    <div v-if="bundleDetails && bundleDetails.products && bundleDetails.products.length > 0" class="row grid-margin">
      <div class="col-md-12">
        <v-product-variants :product-variants="bundleDetails.products" :is-bundle="true" />
      </div>
    </div>
    <div class="text-xs text-slate-700 text-right mr-4 -mt-9">
      {{ bundleDetails.bundleNote }}
    </div>
    <div class="row grid-margin fixed bottom-8 right-48">
      <v-button md cta @click.prevent="orderBundleProducts"> Bestelpakket bestellen </v-button>
    </div>
  </section>
</template>

<script>
import VArrowLeftIcon from 'icons/ArrowLeft';
import router from '@/router';
import axios from 'axios';
import { addIllnessBundleToShoppingCart, shoppingCart$ } from '@/services';
import VProductVariants from '@/components/sections/catalog/productDetail/ProductVariants';
import { ref } from 'vue';

export default {
  name: 'BundleProducts',
  components: {
    VArrowLeftIcon,
    VProductVariants
  },
  setup() {
    const shoppingCart = ref(null);

    shoppingCart$.subscribe((value) => {
      shoppingCart.value = value;
    });

    return {
      shoppingCart
    };
  },
  data() {
    return {
      bundleDetails: {}
    };
  },
  computed: {
    productVariantsAddedToBasket() {
      return this.productVariants;
    }
  },
  created() {
    axios
      .get('Products/GetIllnessBundleDetails?illnessBundleId=' + router.currentRoute.value.params.id)
      .then((response) => {
        if (response && response.data) {
          this.bundleDetails = response.data;
        }
      });
  },
  methods: {
    // Function to go back to the respective catalog page
    goToCatalog() {
      router.push('/catalog');
    },
    // Function to add all bundle products to the cart
    orderBundleProducts() {
      addIllnessBundleToShoppingCart(this.shoppingCart, router.currentRoute.value.params.id);
      this.$emitter.emit('alert', {
        message: 'Alle producten zijn toegevoegd aan de bestellijst.'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bundleProducts {
  .material-design-icon {
    margin-right: 10px;
  }
}
</style>
